import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentStatus } from 'src/app/common';
import { CommunicationEventService } from 'src/app/services/communication-event.service';
import { IrtwadModel, RtwadSearchResult, RtwadService } from 'src/app/services/rtwad.service';

@Component({
  selector: 'app-rtwad-seeker-list',
  templateUrl: './rtwad-seeker-list.component.html',
  styleUrls: ['./rtwad-seeker-list.component.scss']
})
export class RtwadSeekerListComponent implements OnInit {

	constructor(private rtwadService: RtwadService, private eventLog: CommunicationEventService) { }

	search$:  Observable<RtwadSearchResult>;

	selectedStatus: string = "NotPaid,Pending,Started,Rejected";

	ngOnInit(): void {
		// console.log("called");
		this.search$ = this.rtwadService.getMyAds$();
	}

	checkPayment(payment: any){

		switch (payment.Status) {
			case PaymentStatus.Settled:
				this.eventLog.log(this.eventLog.actions.rtwad.owner.paymentSuccess, { RelatedItems: [{ Id: payment.Id, Index: 'readytowork', Relation: 'detail' }] });
				break;
			case PaymentStatus.Failed:
				this.eventLog.log(this.eventLog.actions.rtwad.owner.paymentFailed, { RelatedItems: [{ Id: payment.Id, Index: 'readytowork', Relation: 'detail' }] });
				break;
		}

	}
	
onAdUpdated() {
  this.search$ = this.rtwadService.getMyAds$();
}
}
